
<form class="needs-validation" [formGroup]="myForm" novalidate>
   <div class="col-md-12 mb-3 pad-left">   
      <div class="input-group">
         <div class="custom-file">
            <input #file id ="file" type="file" accept=".gif,.jpg,.jpeg,.png,.doc,.pdf,.docx
            ,.txt,.woff,.json,.ppt,.pptx,.xml,.jpeg,.xls,.xlsx" class="custom-file-input" formControlName="doc"
            (change)="fileChange($event)" aria-label="Browse">
            <label label class="custom-file-label" for="file" aria-hidden="true">
               <ng-container  *ngIf="doc" >{{doc.name}}</ng-container>
            </label>
            <label *ngIf="myForm.controls.doc.errors?.required && myForm.controls.doc.touched || myForm.controls.doc.errors?.fileValidator || myForm.controls.doc.errors?.sizeInvalid" 
               label class="custom-file-label label-error" for="file" aria-hidden="true">
               <ng-container *ngIf="doc" >{{doc.name}}</ng-container> 
            </label>
         </div>
      </div>
      <p class="err" *ngIf="myForm.controls.doc.errors?.required && myForm.controls.doc.touched"> Document is required</p>
      <p class="err" *ngIf="myForm.controls.doc.errors?.fileValidator"> File type not accepted</p>
      <p class="err" *ngIf="myForm.controls.doc.errors?.sizeInvalid"> Please limit file size to 40 MB</p>
      <p class="no-pad gray">Acceptable formats include .doc, .docx, .pdf, .jpg, .xlsx, .xls, .png and .gif</p> 
   </div>
</form>

